import React from 'react';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';

import { NO_OPTION_LABELS } from '../../../libraries/texts';

export const Option = props => {
  const {
    innerRef,
    isFocused,
    isSelected,
    innerProps,
    children,
    selectProps: { classes }
  } = props;

  return (
    <MenuItem
      buttonRef={innerRef}
      selected={isFocused}
      className={classes.wrap}
      component="div"
      style={{
        fontWeight: isSelected ? 500 : 400,
        fontSize: '13px',
        whiteSpace: 'pre-wrap'
      }}
      {...innerProps}
    >
      {children}
    </MenuItem>
  );
};

export const Control = inputComponent => props => {
  const { innerRef, selectProps, innerProps, children } = props;
  return (
    <TextField
      fullWidth
      InputProps={{
        inputComponent,
        inputProps: {
          className: selectProps.classes.input,
          inputRef: innerRef,
          children: children,
          ...innerProps
        }
      }}
      {...selectProps.textFieldProps}
    />
  );
};

export const Placeholder = props => {
  const { selectProps, innerProps, children } = props;
  return (
    <Typography color="textSecondary" className={selectProps.classes.placeholder} {...innerProps}>
      {children}
    </Typography>
  );
};

export const NoOptionsMessage = props => {
  const { selectProps, innerProps, text = '' } = props;
  return (
    <Typography
      color="textSecondary"
      className={selectProps.classes.noOptionsMessage}
      {...innerProps}
    >
      {!text ? NO_OPTION_LABELS : text}
    </Typography>
  );
};

export const checkInPatient = props => {
  const { values, setFieldValue, prefix } = props;

  if (!values['suscriptorDniNumber'] && values[`${prefix}Dni`] !== '') {
    setFieldValue(`${prefix}Dni`, '');
    setFieldValue(`${prefix}DniNumber`, '');
    setFieldValue(`${prefix}SuscriptorCb`, false);
  }

  if (
    values['suscriptorDniNumber'] &&
    values['suscriptorDniNumber'] !== values[`${prefix}DniNumber`] &&
    values['suscriptorDni'] &&
    values['suscriptorDni'] !== values[`${prefix}Dni`]
  ) {
    setFieldValue(`${prefix}Dni`, values['suscriptorDni']);
    setFieldValue(`${prefix}DniNumber`, values['suscriptorDniNumber']);
  }
};
